import { render } from "./GiftTransactions.vue?vue&type=template&id=917ac9f2&scoped=true"
import script from "./GiftTransactions.vue?vue&type=script&lang=js"
export * from "./GiftTransactions.vue?vue&type=script&lang=js"

import "./GiftTransactions.vue?vue&type=style&index=0&id=917ac9f2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917ac9f2"]])

export default __exports__